<form [formGroup]="formGroup">
  <div class="l-contact-privacy">
    <span>
      ご不明な点がございましたら、下記フォームよりお問い合わせください。
    </span>
  </div>
  <div class="l-form-contact">
    <app-input
      label="お名前"
      placeholder="田中　太郎"
      [require]="true"
      formControlName="name"
    ></app-input>

    <app-input
      label="フリガナ"
      placeholder="タナカ　タロウ"
      [require]="true"
      formControlName="kana"
    ></app-input>

    <app-input
      type="email"
      label="メールアドレス"
      placeholder="xxxx@gmail.com"
      [require]="true"
      formControlName="email"
    ></app-input>

    <app-textarea
      label="お問い合わせ内容"
      formControlName="content"
      [require]="true"
      placeholder="内容"
    ></app-textarea>

    <div class="u-bottom">
      <button
        type="button"
        [class]="'c-btn-submit'"
        [value]="'送信する'"
        [disabled]="!formGroup.valid"
        (click)="onAccept()"
      ></button>
    </div>
  </div>
</form>
